import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      propsData: {},
      component: null,
    };
  },
  computed: {},
  watch: {},
  methods: {},
});
